<template>
  <div>
    <Row>
      <Col offset="20" span="4">
        <Drawer
          v-model="if_model_open"
          @on-visible-change="drawer_visible_change"
          :closable="false"
          width="350"
        >
          <div class="demo-drawer-hearde">
            <Row type="flex" justify="center">
              <h2>设置参数</h2>
            </Row>
          </div>
          <Row type="flex" justify="start" align="middle">
            <Tabs
              :animated="false"
              @on-click="tab_select"
              style="height:280px"
              :value="chart_select"
            >
              <TabPane label="MA体系" name="ma">
                <Form label-position="left" :label-width="100" :label-colon="true">
                  <FormItem label="均线参数1">
                    <InputNumber :max="1000" :min="1" v-model="ma_0"></InputNumber>
                  </FormItem>
                  <FormItem label="均线参数2">
                    <InputNumber :max="2000" :min="1" v-model="ma_1"></InputNumber>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="RENKO体系" name="renko">
                <Form label-position="left" :label-width="130" :label-colon="true">
                  <FormItem label="格子幅度(千分之)">
                    <InputNumber :max="10" :min="0.1" :step="0.1" v-model="price_limit_per"></InputNumber>
                  </FormItem>
                  <FormItem label="反向倍数">
                    <InputNumber :max="30" :min="2" v-model="reside_num"></InputNumber>
                  </FormItem>
                  <FormItem label="均线参数1">
                    <InputNumber :max="1000" :min="1" v-model="ma_0"></InputNumber>
                  </FormItem>
                  <FormItem label="均线参数2">
                    <InputNumber :max="2000" :min="1" v-model="ma_1"></InputNumber>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="BOLL体系" name="boll">
                <Form label-position="left" :label-width="190" :label-colon="true">
                  <FormItem label="布林回溯时长">
                    <InputNumber :max="1500" :min="1" v-model="boll_length"></InputNumber>
                  </FormItem>
                  <FormItem label="布林上下轨宽度系数">
                    <InputNumber :max="10" :min="0" v-model="boll_width"></InputNumber>
                  </FormItem>
                  <FormItem label="布林中规宽度系数">
                    <InputNumber :max="1" :min="0" v-model="boll_percent"></InputNumber>
                  </FormItem>
                  <FormItem label="布林中规宽度判定回溯时长">
                    <InputNumber :max="1500" :min="1" v-model="boll_percent_days"></InputNumber>
                  </FormItem>
                </Form>
              </TabPane>
            </Tabs>
          </Row>
          <div class="demo-drawer-footer">
            <Row type="flex" justify="start">
              <Form label-position="left" :label-width="100" :label-colon="true">
                <FormItem label="重采样参数">
                  <InputNumber :max="300" :min="1" v-model="minute_num"></InputNumber>
                </FormItem>

                <FormItem v-if="month_switch" label="行情月份选择">
                  <DatePicker
                    size="small"
                    type="month"
                    v-model="date_picker_month"
                    placeholder="Select month"
                    @on-change="select_date_picker"
                  ></DatePicker>
                  <!-- <DatePicker
                    size="small"
                    type="datetime"
                    v-model="date_picker_datetime"
                    placeholder="Select time range"
                  ></DatePicker> -->
                </FormItem>
                <FormItem v-else label="行情年份选择">
                  <DatePicker
                    size="small"
                    type="year"
                    v-model="date_picker_year"
                    placeholder="Select year"
                    @on-change="select_date_picker"
                  ></DatePicker>
                </FormItem>
                <FormItem label="标的">
                    <Dropdown
                      @on-click="dropdown_click"
                      trigger="click"
                      placement="bottom"
                    >
                      <a href="javascript:void(0)">
                          {{ this.select_symbol }}
                          <Icon type="ios-arrow-down"></Icon>
                      </a>
                      <DropdownMenu slot="list">
                        <DropdownItem v-for="_name in dropdown_item" v-bind:key="_name" v-bind:name="_name">{{_name}}</DropdownItem>
                          <!-- <DropdownItem name="BTCUSDT">BTCUSDT</DropdownItem>
                          <DropdownItem name="ETHUSDT">ETHUSDT</DropdownItem>
                          <DropdownItem name="BNBUSDT">BNBUSDT</DropdownItem>
                          <DropdownItem name="RB9999.XSGE">RB9999</DropdownItem>
                          <DropdownItem name="NI9999.XSGE">NI9999</DropdownItem> -->
                      </DropdownMenu>
                    </Dropdown>
                </FormItem>
                <FormItem label="标的">
                    <Input v-model="select_symbol" clearable maxlength="15"></Input>
                </FormItem>
              </Form>
            </Row>
            <Row type="flex" justify="center">
              <Button type="primary" @click="drawer_click_submit">确定</Button>
              <Button style="margin-left: 20px" @click="if_model_open = false">取消</Button>
            </Row>
          </div>
        </Drawer>
      </Col>
    </Row>
    <Row type="flex" justify="space-between">
      <Col span="24">
        <div ref="ma_k_line_ref" :style="contentStyleObj"></div>
      </Col>
    </Row>
    <Row>
      <Col :offset="23" :span="1">
        <Button ref="drawer_button" @click="click_drawer" icon="ios-settings" v-show="false"></Button>
      </Col>
    </Row>
  </div>
</template>

<script>
import echarts from "echarts"
import {
  draw_history_kline_chart,
  draw_history_boll_chart,
  array_to_object,
  history_chart_set_loading
} from "../utils";

export default {
  name: "history_data",
  components: {},
  data() {
    return {
      timer: null,
      minute_num: 1,
      select_symbol:"RB9999.",
      ma_0: 30,
      ma_1: 120,
      price_limit_per: 1,
      reside_num: 2,
      date_picker_year: "2022",
      date_picker_month:"2022-01",
      date_picker_datetime:null,
      if_model_open: false,
      month_switch: true,
      dropdown_item:["RB9999.", "P9999.", "i9999.", "MA2307."],
      history_kline_chart_name:"历史行情(按月)",
      storage_buff_index: [
        "minute_num",
        "select_symbol",
        "date_picker_year",
        "date_picker_month",
        "month_switch",
        "ma_0",
        "ma_1",
        "boll_length",
        "boll_width",
        "boll_percent"
      ],
      params_set: {},
      k_line_data: null,
      my_chart: null,
      boll_length: 60,
      boll_width: 4,
      boll_percent: 0.2,
      boll_percent_days: 40,
      chart_select: "ma",
      flag_after_drawer_click_submit: false,
      // 标记是否需要从服务器重新获取一次数据
      if_load_new_data:true,
      contentStyleObj:{
        float:'left',
        height:window.innerHeight - 150 + 'px',
        width:'100%'
      },
    };
  },
  methods: {
    tab_select: function(name) {
      this.chart_select = name;
      localStorage.setItem("tab_select_name_history_data", name);
    },
    select_date_picker: function(value) {
      if (this.month_switch == true) {
        var year_month = value.split("-")
        if (year_month[0] < 2018) {
          this.date_picker_month = "2018-01"
        }
      } else {
        var year_month = value
        if (value < 2015) {
          this.date_picker_year = "2015"
        }
      }
      this.if_load_new_data = true
    },
    click_drawer: function() {
      this.if_model_open = true;
    },
    drawer_visible_change: function(visible) {
      if (visible == true) {
        this.flush_kline_params();
      }
    },
    drawer_click_submit: function() {
      this.if_model_open = false;
      this.load_data_from_service(this.if_load_new_data);
      if (this.chart_select == "renko") {this.if_load_new_data = true;} else {this.if_load_new_data = false;}
      this.flush_kline_params();
      this.flag_after_drawer_click_submit = true;

      // var myChart = echarts.init(this.$refs.ma_k_line_ref, "essos")
      // myChart.setOption({
      //       dataZoom: [
      //           {
      //               startValue: '2023-07-23 21:00:59',
      //               endValue: '2023-07-23 22:00:59'
      //           }
      //       ]
      //   });
    },
    load_data_from_service: async function(if_load_new_data = true) {
      if (if_load_new_data == true) {
        history_chart_set_loading(this.$refs.ma_k_line_ref, "正在加载数据");
        if (this.chart_select == "boll") {
          draw_history_boll_chart(
            this.$refs.ma_k_line_ref,
            this.$refs.drawer_button,
            this.history_kline_chart_name,
            [],
            this.minute_num,
            this.boll_length,
            this.boll_width,
            this.boll_percent,
            this.boll_percent_days,
            true
          );
        } else if (this.chart_select == "ma") {
          draw_history_kline_chart(
            this.$refs.ma_k_line_ref,
            this.$refs.drawer_button,
            this.history_kline_chart_name,
            [],
            this.minute_num,
            this.ma_0,
            this.ma_1,
            true
          );
        } else {
          // renko部分, 交给tornado端处理
          draw_history_kline_chart(
            this.$refs.ma_k_line_ref,
            this.$refs.drawer_button,
            this.history_kline_chart_name,
            [],
            this.minute_num,
            this.ma_0,
            this.ma_1,
            true
          );
        };
        
        if (this.month_switch == true) {
          if (typeof this.date_picker_month != "string") {
              this.date_picker_month =
                this.date_picker_month.getFullYear() + "-" + (this.date_picker_month.getMonth() + 1)
          }
        } else {
          if (typeof this.date_picker_year != "string") {
            this.date_picker_year =
              this.date_picker_year.getFullYear()
          }
        }

        if (this.month_switch == true) {
          var _mode = "data_kline_month"
          var params_set = {
            "date_picker": this.date_picker_month,
            "select_symbol": this.select_symbol
          }
        } else {
          var _mode = "data_kline_year"
          var params_set = {
            "date_picker": this.date_picker_year,
            "select_symbol": this.select_symbol
          }
        }
        if (this.chart_select == "renko") {
          params_set["renko"] = [this.price_limit_per/1000, this.reside_num]
        }
        try {
          let data = await this.$axios.get(
            this.$store.state.urlPort + "/load_echarts_data",
            {
              params: {
                mode: _mode,
                which_web_need: this.strategy_id,
                params_set: params_set
              }
            }
          );
          this.k_line_data = data["data"];
        } catch(error) {
          history_chart_set_loading(this.$refs.ma_k_line_ref, null);
        }
        
      } else {
        history_chart_set_loading(this.$refs.ma_k_line_ref, "正在重绘数据");
      }

      setTimeout(() => {
        if (this.month_switch == true) {
          var title = this.params_set["date_picker_month"]
        } else {
          var title = this.params_set["date_picker_year"]
        }
        if (this.chart_select == "boll") {
          draw_history_boll_chart(
            this.$refs.ma_k_line_ref,
            this.$refs.drawer_button,
            this.history_kline_chart_name + title,
            this.k_line_data,
            this.minute_num,
            this.boll_length,
            this.boll_width,
            this.boll_percent,
            this.boll_percent_days,
            this.flag_after_drawer_click_submit
          );
        } else {
          draw_history_kline_chart(
            this.$refs.ma_k_line_ref,
            this.$refs.drawer_button,
            this.history_kline_chart_name + title,
            this.k_line_data,
            this.minute_num,
            this.ma_0,
            this.ma_1,
            this.flag_after_drawer_click_submit
          );
        }
        this.flag_after_drawer_click_submit = false;
        history_chart_set_loading(this.$refs.ma_k_line_ref, null);
      }, 300);
    },
    load_param_from_local_storage: function() {
      //localStorage.setItem("token", token);
      if (localStorage.hasOwnProperty("history_params_set")) {
        var params_set_temp = localStorage.getItem("history_params_set");
        if (params_set_temp == null) {
          return null;
        } else {
          params_set_temp = JSON.parse(params_set_temp);
          for (var i = 0; i < this.storage_buff_index.length; i++) {
            var key = this.storage_buff_index[i];
            if (params_set_temp.hasOwnProperty(key) == true) {
              this[key] = params_set_temp[key];
            }
          }
        }
      }

      if (localStorage.hasOwnProperty("tab_select_name_history_data")) {
        this.chart_select = localStorage.getItem(
          "tab_select_name_history_data"
        );
      }
    },
    flush_kline_params: function() {
      if (this.month_switch == true) {
        var date_picker = this.date_picker_month
      } else {
        var date_picker = this.date_picker_year
      }

      if (date_picker instanceof Date) {
        if (this.month_switch == true) {
            date_picker =
                date_picker.getFullYear() +
                "-" +
                (date_picker.getMonth() + 1)
          } else {
            date_picker = date_picker.getFullYear()
          }
      }
      if (typeof date_picker === "number") {
        date_picker = "" + date_picker
      }

      if (this.month_switch == true) {
        this.date_picker_month = date_picker
      } else {
        this.date_picker_year = date_picker
      }

      for (var i = 0; i < this.storage_buff_index.length; i++) {
        var key = this.storage_buff_index[i];
        this.params_set[key] = this[key];
      }
      localStorage.setItem(
        "history_params_set",
        JSON.stringify(this.params_set)
      );
    },
    dropdown_click: function(name) {
      this.select_symbol = name
      this.if_load_new_data = true
      this.month_switch = true
      this.history_kline_chart_name = "历史行情(按月)"
      // if (name.indexOf(".") != -1) {
      //   this.month_switch = false
      //   this.history_kline_chart_name = "历史行情(按年)"
      // } else {
      //   this.month_switch = true
      //   this.history_kline_chart_name = "历史行情(按月)"
      // }
    }
  },
  watch: {

  },
  mounted() {
    this.strategy_id = this.$route.path.split("=")[1]
    this.load_param_from_local_storage()
    this.dropdown_click(this.select_symbol)
    this.flush_kline_params()
    //var body_height = document.documentElement.clientHeight || document.body.clientHeight
    //this.$refs.ma_k_line_ref.style.height = parseInt(body_height * 0.8) +'px';
    //console.log("当前子策略 账户_策略编号:", this.strategy_id);
    //this.ma_k_line_ref = "ma_k_line_" + this.strategy_id
    this.load_data_from_service()
    

    let selected_points = [];
    let selected_points_time = []
    let selected_indices = [];
    var myChart = echarts.init(this.$refs.ma_k_line_ref, "essos");
    myChart.on('click', function (params) {
        selected_points.push(params.data);
        selected_points_time.push(params.name);
        selected_indices.push(params.dataIndex);
        if (selected_points.length === 2) {
            // 计算涨幅
            var startPrice = selected_points[0][1];  // 开盘价
            var endPrice = selected_points[1][2];  // 收盘价
            console.log("时间: " + selected_points_time[0] + "--" + selected_points_time[1])
            console.log("涨幅: " + (100*(endPrice / startPrice - 1)).toFixed(2) + "% 收盘价:" + endPrice + " 开盘价:" + startPrice);
            
            var y_axis_data = myChart.getOption().series[0].data;
            // 获取两次点击之间的所有数据
            var dataBetween = y_axis_data.slice(
                Math.min(...selected_indices),
                Math.max(...selected_indices) + 1
            );
            // 计算最高价和最低价
            var max_price = Math.max(...dataBetween.map(data => data[3]));
            var min_price = Math.min(...dataBetween.map(data => data[2]));

            console.log("波幅: " + (100*(max_price / min_price - 1)).toFixed(2) + "% 最高价:" + max_price + " 最低价:" + min_price);
            console.log("-----------")
            

            // 清空选中的点
            selected_points = [];
            selected_points_time = [];
            selected_indices = [];
        }
    });
  },
  beforeMount: function() {},
  created: function() {},
  destroyed() {}
};
</script>

<style scoped>
.demo-drawer-footer {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 15px 0px;
  text-align: left;
  background: #fff;
}
.demo-drawer-hearde {
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
  text-align: right;
  background: #fff;
}
</style>